import { render, staticRenderFns } from "./RptOfertasPromciones.vue?vue&type=template&id=4fed0e11&"
import script from "./RptOfertasPromciones.vue?vue&type=script&lang=js&"
export * from "./RptOfertasPromciones.vue?vue&type=script&lang=js&"
import style0 from "./RptOfertasPromciones.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports